<div class="servererror-page">
    <div class="inner-container">
        <div class="message-box">
            <h1>Whoops!</h1>
            <h3>The server ran into a problem.</h3>
            <img src="../../../assets/500/ugood.png" alt="">
        </div>
    </div>
</div>
